import * as React from "react";
import { Col, Row } from "react-grid-system";
import { IoIosArrowBack } from "react-icons/io";
import styled from "styled-components";
import InputSearch from "../utils/InputSearch";
import Loader from "../utils/Loader";
import Card from "./Card";

export default function Filters(props: any) {
  const [loadingFilter, setLoaderFilter] = React.useState(false);
  const [loader, setLoader] = React.useState(false);

  const [inputsearch, setInputSearch] = React.useState("");

  const [data, setData] = React.useState<any>(null);
  const [datcopy, setDataCopy] = React.useState<any>(null);

  React.useEffect(() => {
    getDataFormat();
  }, []);

  const getDataFormat = () => {
    setLoader(true);
    const data = props.data;

    let total_items: any = [];

    data.map((item: any) => {
      if (item.items) {
        total_items.push(item.items);
      }
    });

    let total_menu: any = [];
    total_items.map((dt: any) => {
      dt.map((dt_: any) => {
        total_menu.push(dt_);
      });
    });
    setData(total_menu);
    setDataCopy(total_menu);
    setTimeout(() => {
      setLoader(false);
    }, 500);
  };

  const handleTextFilter = (e: any) => {
    setLoader(true);
    const value = e.target.value;
    setInputSearch(value);

    const temporal: any = [...data];
    let response: any = [];

    if (!value) {
      let data_ = [...data];
      setDataCopy(data_);
    }

    if (value) {
      response = temporal.filter((res: any) => {
        return res.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
      });
      setDataCopy(response);
    }
    setTimeout(() => {
      setLoader(false);
    }, 500);
  };

  const handleAddItem = () => {};

  return (
    <ContentFilters>
      <header>
        <Row align="center">
          <Col xs={2}>
            <button onClick={() => props.closeFilter()}>
              <IoIosArrowBack />
            </button>
          </Col>
          <Col>
            {/* <InputSearch
                loading={loadingFilter}
                placeholder="Buscar...."
                className="form-control"
                sm="true"
                value={""}
                onChange={handleTextFilter}
                style={{ width: "90%" }}
              /> */}
          </Col>
        </Row>
      </header>
      <main className="main_filter">
        <div className="results">
          {loader && (
            <div className="w-100 text-center">
              <Loader color="#3498db" />
            </div>
          )}
          {!loader && (
            <>
              {datcopy && (
                <>
                  <div className="text-center text-dark pt-2">
                    <h4> {datcopy.length} productos </h4>
                  </div>
                  {datcopy.map((item: any, indx: any) => (
                    <div key={indx}>
                      <Card
                        data={item}
                        type={"vertical"}
                        handleAddItem={handleAddItem}
                        show_order={true}
                      />
                    </div>
                  ))}
                </>
              )}
            </>
          )}
        </div>
      </main>
    </ContentFilters>
  );
}

const ContentFilters = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  /* min-height: 100vh; */
  height: 100vh;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  z-index: 4;
  header {
    width: 100%;
    position: fixed;
    top: 0;
    padding: 1em 0;
    background: white;
    color: #2c3e50;
    z-index: 1;
    button {
      border: none;
      background: white;
      padding: 0.8em 1em;
      box-shadow: 0px 0px 10px #0000012f;
      border-radius: 6px;
      color: #2c3e50;
      svg {
        font-size: 1.5em;
        margin-top: -5px;
      }
    }
  }
  .main_filter {
    margin-top: 4em;
  }
  input {
    font-weight: 500;
    font-size: 1em;
    border: 0;
    outline: none;
  }
  .results {
    width: 100%;
    min-height: 60vh;
  }
`;
